<template>
  <div class="chat-temporary-item">
    <div class="message-wrapper" :class="`${getMessageClassByType()}`">
      <div class="conversation-message">
        <span class="message-title">{{ getMessageText() }}</span>
      </div>
      <div class="message-button" :class="`${getMessageButtonClassByType()}`" @click="onProBuy">
        <div class="temporary-button">
          <span class="button-title">{{ getMessageButtonText() }}</span>
        </div>
      </div>
      <div class="message-button" v-if="message.trialCount && message.trialCount > 0" @click="onResetSendQusition">
        <div class="free-temporary-button">
          <span class="button-title">{{ $t("chat_button_bottom_title") }}</span>
        </div>
      </div>
      <div class="button-bottom" v-if="message.trialCount && message.trialCount > 0">
        <span class="button-bottom-tip">{{ $t("chat_button_bottom_tips") }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {defineEmits, watch} from "vue";
const { t } = useI18n()
import type { Message } from "@/data/chat/Message";

let call = defineEmits(["updateContentHeight", "resetSendQusition", "proBuy"])

interface Props {
  type: number,  // 1 登录 2 升级vip 3 加油包
  message: Message
}
const props = defineProps<Props>()

const getMessageButtonClassByType = () => {
  let className = ""
  if (props.message.chargeStatus == 1) {
    className = 'chat-vip-button-wrapper'
  }else if (props.message.chargeStatus == 2) {
    className = 'chat-fuelbag-button-wrapper'
  }
  return className
}

const getMessageClassByType = () => {
  let className = ""
  if (props.message.chargeStatus == 2) {
    className = 'chat-vip-wrapper'
  }else if (props.message.chargeStatus == 1) {
    className = 'chat-fuelbag-wrapper'
  }
  return className
}

const getMessageButtonText = () => {
  let text = ""
  if (props.message.chargeStatus == 2) {
    text = t('chat_porary_buy_vip')
  }else if (props.message.chargeStatus == 1) {
    text = t('chat_porary_buy_bag')
  }
  return text
}

const getMessageText = () => {
  let text = ""
  if (props.message.chargeStatus == 1) {
    text =  t('chat_porary_content_user')
  }else if (props.message.chargeStatus == 2) {
    text =  t('chat_porary_content_vip')
  }
  return text
}

function onResetSendQusition() {
  if (props.message && props.message.msgJsonContent.text){
    call("resetSendQusition", {content: props.message.msgJsonContent.text, isFree: true})
  }
}

const { vipItems, bagItems } = useLocalBuy()
const proDialogRef = inject('proDialogRef') as Ref
function onProBuy() {
  let items = (props.message.chargeStatus == 2 ? vipItems.value : bagItems.value)
  proDialogRef?.value && proDialogRef?.value.open({...items[0], mode: 1})
}

onMounted(()=>{
  call("updateContentHeight")
})

</script>

<style lang="less">
.chat-temporary-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  .message-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 4px;
    margin-bottom: 4px;
    position: relative;
    max-width: 100%;
    border-radius: 10px 10px 10px 10px;
    .conversation-message {
      border-radius: 8px;
      padding: 10px 12px;
      border-radius: 8px;
      font-size: 14px;
      overflow-wrap: break-word;
      box-sizing: border-box;
      max-width: 100%;
      .message-title {
        color: #262626;
        font-size: 14px;
        max-width: 100%;
        line-height: 20px;
      }
    }
    .button-bottom {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 12px 10px 12px;
      position: relative;
      max-width: 100%;
      width: calc(100% - 24px);
      .button-bottom-tip {
        color: #8C8C8C;
        font-size: 12px;
      }
    }
    
    .message-button {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 12px 10px 12px;
      position: relative;
      max-width: 100%;
      width: calc(100% - 24px);
      cursor: pointer;
      // background: linear-gradient( 134deg, #E5F2FB 0%, #D5F9FF 100%);
      border-radius: 4px 4px 4px 4px;
      .temporary-button {
        width: 100%;
        height: 40px;
        border-radius: 4px 4px 4px 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .button-title {
          color: white;
          font-size: 14px;
        }
      }
      &:hover {
        opacity: 0.6;
      }
      .free-temporary-button {
        width: 100%;
        height: 40px;
        border-radius: 4px 4px 4px 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background-color: white;
        border: 1px solid #E29856;
        .button-title {
          color: #E29856;
          font-size: 14px;
        }
      }
    }
  }
}

.chat-user-wrapper {
  background: linear-gradient( 134deg, #E5F2FB 0%, #D5F9FF 100%);
}

.chat-vip-wrapper {
  background: linear-gradient( 134deg, #FEF9F3 0%, #FDF1E3 100%);
}

.chat-fuelbag-wrapper {
  background: linear-gradient( 134deg, #EEFBF1 0%, #D6EDDD 100%);
}

.chat-user-button-wrapper {
  background: #2590E1;
  border: 1px solid #2590E1;
}

.chat-vip-button-wrapper {
  background: #E29856;
  border: 1px solid #E29856;
}

.chat-fuelbag-button-wrapper {
  background: #34A853;
  border: 1px solid #34A853;
}
</style>
